import { useMutation as useApolloMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

import type { Response, MutationVars } from './mutation'
import cancelDataRequestMutation from './mutation'

export const useCancelDataRequestMutation: WrappedMutation<Response, MutationVars> = () =>
  useApolloMutation<Response, MutationVars>(cancelDataRequestMutation, {
    client: agentClient,
    fetchPolicy: 'network-only',
  })
